export default __webpack_public_path__ + "static/media/colored-symbol.79281c44.svg";